import { render, staticRenderFns } from "./AuthoriseLabourOld.vue?vue&type=template&id=7d8fb330&scoped=true"
import script from "./AuthoriseLabourOld.vue?vue&type=script&lang=js"
export * from "./AuthoriseLabourOld.vue?vue&type=script&lang=js"
import style0 from "./AuthoriseLabourOld.vue?vue&type=style&index=0&id=7d8fb330&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8fb330",
  null
  
)

export default component.exports